import React, { useCallback } from 'react';
import { useState } from 'react';

const dayLabels = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

function isLaterDay(d1: Date, d2: Date): boolean {
  try {
    const a = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
    const b = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate());
    return a.getTime() > b.getTime();
  } catch (e) {
    return false;
  }
}

function getDatesFromToday(count: number): Date[] {
  const dates: Date[] = [];
  const today = new Date();
  for (let i = 0; i < count; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    dates.push(d);
  }
  return dates;
}

export function EPGDateSelector({
  onDateChange,
  latestDate,
  todayIso,
}: {
  onDateChange: (isoDate: string) => void;
  latestDate: string;
  todayIso: string;
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const dates = getDatesFromToday(7);

  const handleClick = useCallback(
    (date: Date, index: number) => {
      setSelectedIndex(index);
      const iso =
        index === 0
          ? todayIso
          : new Date(
              Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
            ).toISOString();
      onDateChange(iso);
    },
    [onDateChange, todayIso]
  );

  return (
    <div className="flex gap-day_filter_horizontal_gutter overflow-x-auto whitespace-nowrap font-day_filter_font_family text-day_filter_font_size leading-day_filter_line_height tracking-day_filter_letter_spacing scrollbar-hide">
      {React.Children.toArray(
        dates.map((date, i) => {
          if (isLaterDay(date, new Date(latestDate))) return null;

          return (
            <button
              key={i}
              className={`shrink-0 rounded-day_filter_corner_radius pb-day_filter_padding_bottom pl-day_filter_padding_left pr-day_filter_padding_right pt-day_filter_padding_top
            ${
              i === selectedIndex
                ? 'bg-day_filter_selected_background_color text-day_filter_selected_font_color'
                : 'bg-day_filter_default_background_color text-day_filter_default_font_color'
            }`}
              onClick={() => handleClick(date, i)}
            >
              {i === 0
                ? 'TODAY'
                : `${dayLabels[date.getDay()]}, ${date.getDate()}`}
            </button>
          );
        })
      )}
    </div>
  );
}
